import { Outlet } from 'react-router-dom';
import styles from './ManageAccountPage.module.scss';
import classNames from 'classnames';
import { useBanner } from 'src/hooks/useBanner';

export const ManageAccountPage = () => {
  const { bannersSet } = useBanner();

  return (
    <div
      className={classNames(styles.root, {
        [styles.reducedHeight]: bannersSet.length !== 0,
      })}
    >
      <div className={styles.container}>
        <Outlet />
      </div>
    </div>
  );
};
